import { Component, Input, OnInit } from '@angular/core';
import { TaskCommentObject } from 'src/app/models/tasks/tasks-details/tasks-details-comments/task-comment.model';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';

@Component({
  selector: 'app-tasks-details-comments',
  templateUrl: './tasks-details-comments.component.html',
  styleUrls: ['./tasks-details-comments.component.css']
})
export class TasksDetailsCommentsComponent implements OnInit {

  taskDetailsComments: Array<TaskCommentObject>;
  listLength: number;
  objectFetched = false;

  @Input() taskDetails: TaskDetailsObject;

  constructor() {
  }

  ngOnInit() {
    this.taskDetailsComments = this.taskDetails.getComments();
    this.listLength = this.taskDetailsComments.length;
  }

}
